import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faCommentDots, faXmark } from '@fortawesome/free-solid-svg-icons';
import { LOG_PROMPTS, LOG_PROMPT_HINT, contactActions } from '../../shared/crm/contactLinks';

const ICONS = { call: faPhone, whatsapp: faCommentDots, email: faEnvelope };

/*
 * Call, WhatsApp and Email for a contact or a company, using the computer's own apps. After one
 * is used, a bar asks to log it, with the type and time already filled in. The app does the same
 * (mobile/src/components/crm/LogPrompt.tsx).
 */
export default function CRMContactActions({ type, record, onLog, disabled = false }) {
    const [prompt, setPrompt] = useState(null);
    useEffect(() => { setPrompt(null); }, [record.id]);
    const actions = contactActions(type, record);
    if (!actions.length) return null;
    const firstName = (type === 'contacts' && record.firstName) || record.name;
    return <div className="crm-contact-actions">
        <div className="crm-contact-links" aria-label={`Contact ${record.name}`}>
            {actions.map(action => <a key={action.key} className="crm-button" href={action.href} target={action.key === 'whatsapp' ? '_blank' : undefined} rel="noopener noreferrer" onClick={() => setPrompt({ key: action.key, at: new Date().toISOString() })}><FontAwesomeIcon icon={ICONS[action.key]} /> {action.label}</a>)}
        </div>
        {prompt && !disabled && <div className="crm-log-prompt" role="status">
            <span><strong>{LOG_PROMPTS[prompt.key].question(firstName)}</strong> {LOG_PROMPT_HINT}</span>
            <button type="button" className="crm-button crm-primary" onClick={() => { const { kind } = LOG_PROMPTS[prompt.key]; setPrompt(null); onLog(type, record.id, { kind, date: prompt.at }); }}>{LOG_PROMPTS[prompt.key].button}</button>
            <button type="button" className="crm-icon-button" aria-label="Not now" onClick={() => setPrompt(null)}><FontAwesomeIcon icon={faXmark} /></button>
        </div>}
    </div>;
}
